import { useQuery } from '@tanstack/react-query'

import { ApiError } from '@/lib/apiErrors'
import { toI18nKey } from '@/lib/toI18nKey'
import { getMenuCategories } from '@/shared/api/menu'

export function useMenuCategories(ref: string, scheduleId: string) {
	const query = useQuery({
		queryKey: ['menu', 'categories', ref, scheduleId],
		queryFn: () => getMenuCategories(ref, scheduleId),
		enabled: ref !== '' && scheduleId !== '',
	})

	const errorKey =
		query.error != null
			? toI18nKey('olo:menu', query.error instanceof ApiError ? query.error.code : 'UNKNOWN')
			: null

	return { ...query, errorKey }
}
